import CalendarMonthIcon from "@mui/icons-material/CalendarMonth"
import { Box, Chip, CircularProgress, Divider, Typography } from "@mui/material"
import { ReactElement } from "react"

interface MonthHeaderProps {
    label: string
    recordCount: number
    isLoading: boolean
    monthKey: string
    recordLabel?: string
}

const MonthHeader = ({
    label,
    recordCount,
    isLoading,
    monthKey,
    recordLabel = "application",
}: MonthHeaderProps): ReactElement => (
    <Box
        data-month-key={monthKey}
        sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            pt: 3,
            pb: 1,
        }}
    >
        <CalendarMonthIcon color="action" fontSize="small" />
        <Typography variant="h6" fontWeight={600}>
            {label}
        </Typography>
        <Chip
            label={`${recordCount} ${recordLabel}${recordCount !== 1 ? "s" : ""}`}
            size="small"
            color="default"
            variant="outlined"
            sx={{ visibility: recordCount > 0 ? "visible" : "hidden" }}
        />
        <CircularProgress
            size={18}
            sx={{
                ml: 1,
                visibility: isLoading ? "visible" : "hidden",
            }}
        />
        <Divider sx={{ flexGrow: 1 }} />
    </Box>
)

export default MonthHeader
